import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { WiseAceLogo } from "@/components/WiseAceLogo";

export function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4" data-testid="auth-loading">
        <WiseAceLogo size={52} />
        <div className="h-1.5 w-40 bg-slate-200 rounded-full overflow-hidden">
          <div className="h-full w-1/2 bg-[#D4AF37] animate-pulse rounded-full" />
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}
